<template>
    <el-card>
        <!-- /* ---------------------------------- 表单查询 ---------------------------------- */ -->
        <el-row>
            <el-form :model="form" v-bind="formProps.form" :rules="{}">
                <el-form-item prop="formTime" :label="$t('orders.label.form.submitTime')">
                    <range-date-picker ref="datePick" @showDateTime="handleShowTime" />
                </el-form-item>
                <el-form-item :label="$t('withdraw.label.merchatNo')" prop="merchantNo">
                    <el-input v-model="form.merchantNo" />
                </el-form-item>
                <el-form-item :label="$t('usdt.label.wallet')" prop="payAddress">
                    <el-input v-model="form.payAddress" />
                </el-form-item>
                <el-form-item :label="$t('withdraw.label.withdrawalNo')" prop="merchatOrderNo">
                    <el-input v-model="form.merchatOrderNo" />
                </el-form-item>
                <el-form-item :label="$t('withdraw.label.withdrawalStatus')" prop="withdrawalStatus">
                    <el-select v-model="form.withdrawalStatus">
                        <el-option v-for="item in statusData.withdrawalStatus" :key="item.label" :label="item.label"
                            :value="item.value"></el-option>
                        <el-option :label="$t('btns.emptyValue')" value=""></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button size="mini" type="success" @click="handleEmpty()">{{
                        $t("btns.empty")
                        }}
                    </el-button>
                    <el-button size="mini" type="primary" @click="handleSearch()">{{
                        $t("btns.search")
                        }}
                    </el-button>
                </el-form-item>
            </el-form>
        </el-row>

        <!-- /* ---------------------------------- 表格展示 ---------------------------------- */ -->
        <el-row>
            <div class="header-table">
                <ul class="list-table">
                    <li class="li-table">
                        <em class="label">
                            <span>
                                {{ $t("withdraw.label.withdrawalAmountTotal") }}
                            </span>
                            <span>：</span>
                        </em>
                        <span class="value">
                            {{ totalData.withdrawalAmountTotal | toThousands }}
                        </span>
                    </li>
                    <li class="li-table">
                        <em class="label">
                            <span>
                                {{ $t("withdraw.label.handlingFeeTotal") }}
                            </span>
                            <span>：</span>
                        </em>
                        <span class="value">
                            {{ totalData.handlingFeeTotal | toThousands }}
                        </span>
                    </li>
                </ul>

                <el-button v-if="tableList.length > 0" @click="handleExport()">
                    {{ $t("btns.export") }}
                </el-button>
            </div>

            <el-table :data="tableList" v-loading="loading" :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ textAlign: 'center' }" stripe>
                <el-table-column type="index" label="#"></el-table-column>
                <el-table-column prop="account" :label="$t('withdraw.label.account')"></el-table-column>
                <el-table-column :label="$t('clientmanage.table.merchantNo')" prop="merchatNo"></el-table-column>
                <el-table-column prop="actualTransferAmount" :label="$t('withdraw.label.actualTransferAmount')">
                    <template slot-scope="{ row }">
                        {{ row.actualTransferAmount | toThousands }}
                    </template>
                </el-table-column>
                <el-table-column prop="payAddress" :label="$t('usdt.label.wallet')"></el-table-column>
                <el-table-column prop="createTime" :label="$t('withdraw.label.createTime')">
                    <template slot-scope="{ row }">
                        {{ row.createTime | asDayjs }}
                    </template>
                </el-table-column>
                <el-table-column prop="handlingFee" :label="$t('withdraw.label.handlingFee')"></el-table-column>
                <el-table-column prop="type" :label="$t('withdraw.label.type')"></el-table-column>
                <el-table-column width="200px" prop="updateTime" :label="$t('withdraw.label.updateTime')">
                    <template slot-scope="{ row }">
                        {{ row.updateTime | asDayjs }}
                    </template>
                </el-table-column>
                <el-table-column prop="withdrawalNo" :label="$t('withdraw.label.withdrawalNo')"></el-table-column>
                <el-table-column prop="withdrawalStatus" :label="$t('withdraw.label.withdrawalStatus')">
                    <template slot-scope="{ row }">
                        <template v-for="item in statusData.withdrawalStatus">
                            <el-tag :key="item.label" :type="item.type" v-if="item.value == row.withdrawalStatus">
                                {{ item.label }}
                            </el-tag>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('withdraw.label.action')" width="150px"
                    v-if="permission.indexOf('withdraw:usdt:review') != -1">
                    <template slot-scope="{ row }" v-if="row.withdrawalStatus == 0">
                        <el-button size="mini" type="danger" @click="handleReview(row, 1)">
                            {{ $t("btns.pass") }}
                        </el-button>
                        <el-button size="mini" type="primary" @click="handleReview(row, 2)">
                            {{ $t("btns.reject") }}
                        </el-button>
                    </template>
                    <el-tag type="info" v-else>
                        {{ $t("status.finish") }}
                    </el-tag>
                </el-table-column>
            </el-table>
        </el-row>

        <v-pagination v-model="pagination" :total="tableData.rows" @update="getTableData" />
    </el-card>
</template>

<script>
    import usdtApi from "@/api/usdt";
    import { debounce } from "lodash";
    import { isNumber, betweenLenNumber } from "@/utils/validate";
    import { mapGetters } from "vuex";
    import RangeDatePicker from "../cuscom/range-date-picker.vue";
    import base from "@/mixin/base.js"
    export default {
        mixins: [base],
        name: "merchantWithdraw",
        components: { RangeDatePicker },
        data() {
            return {
                loading: true,
                formTime: [],
                updateTimeRange: "",
                form: {},
                pagination: {
                    no: 1,
                    size: this.$defaultPaginationSize
                },
                tableData: {}, // 表格数据
                totalData: {}
            };
        },
        computed: {
            ...mapGetters(["permission", "WITHDRAW_ORDER"]),
            tableList() {
                // 表格list
                return this.tableData.list || [];
            },
            btnsTime() {
                return this.$t("orders.btns");
            },
            statusData() {
                return {
                    withdrawalStatus: [
                        {
                            value: 2,
                            type: "danger",
                            label: this.$t("status.error3")
                        },
                        {
                            value: 1,
                            type: "success",
                            label: this.$t("status.success3")
                        },
                        {
                            value: 0,
                            type: "info",
                            label: this.$t("status.doing1")
                        }
                    ],
                    orderStatus: [
                        {
                            value: 0,
                            type: "danger",
                            label: this.$t("status.error1")
                        },
                        {
                            value: 1,
                            type: "",
                            label: this.$t("status.success1")
                        },
                        {
                            value: 2,
                            type: "info",
                            label: this.$t("status.errorafter")
                        },
                        {
                            value: 3,
                            type: "success",
                            label: this.$t("status.success")
                        }
                    ]
                };
            }
        },
        watch: {
            WITHDRAW_ORDER(n) {
                const _n = n || {};
                this.$notify.success(this.$t("tips.tip2", { money: _n.withdrawalAmount }));
                debounce(() => {
                    this._handleSearch();
                    this.getTotalData();
                }, 2000)();
            }
        },
        created() {
            this.init();
        },
        mounted() {
            this.getTableData();
            this.getTotalData();
        },
        methods: {
            handleShowTime(val) {
                this.formTime = val
            },
            init() {
                this.handleSearch = debounce(() => {
                    this._handleSearch();
                    this.getTotalData();
                }, 300);
                this.handleEmpty();
                /* ----------------------------- element -props ----------------------------- */
                this.formProps = {
                    form: {
                        ref: "form",
                        inline: true,
                        size: "small"
                    },
                    form1: {
                        ref: "form",
                        inline: true,
                        size: "small",
                        rules: {
                            bankNo: [
                                {
                                    required: true,
                                    message: this.$t("withdrawBank.rules.bankNo.required"),
                                    trigger: "blur"
                                },
                                {
                                    validator: (rules, value, cb) => {
                                        if (!isNumber(value)) {
                                            cb(new Error(this.$t("withdrawBank.rules.bankNo.type")));
                                        } else if (!betweenLenNumber(5, 30, value)) {
                                            cb(new Error(this.$t("withdrawBank.rules.bankNo.length")));
                                        } else {
                                            cb();
                                        }
                                    },
                                    trigger: "blur"
                                }
                            ]
                        }
                    }
                };
                /* ------------------------------- status 选择数据 ------------------------------ */
            },
            formatParams() {
                const [createTimeStart, createTimeEnd] = this.formTime;
                // if (!createTimeStart || !createTimeEnd) {
                //   // 若用户点击了时间表单的清空，则重新默认选择当天数据
                //   this.$refs.datePick.handleTime();
                // }
                return {
                    ...Object.keys(this.form).reduce((acc, key) => {
                        if (this.form[key] === 0 || this.form[key]) {
                            acc[key] = this.form[key];
                        }
                        return acc;
                    }, {}),
                    createTimeStart: createTimeStart,
                    createTimeEnd: createTimeEnd
                };
            },
            async getTableData() {
                this.loading = true;
                const params = {
                    data: {
                        no: this.pagination.no,
                        size: this.pagination.size,
                        query: { ...this.formatParams() }
                    }
                };
                const { data } = await usdtApi.getWithdrawOrders(params);
                if (data && data.code === 200) {
                    this.loading = false;
                    this.tableData = data.data;
                } else {
                    this.loading = false;
                    this.$message.error(data.msg);
                }
                return "finished";
            },
            async getTotalData() {
                const { data } = await usdtApi.countWithdrawOrder(this.formatParams());
                if (data && data.code === 200) {
                    this.totalData = data.data || {};
                } else {
                    this.$message.error(data.msg);
                }
            },
            handleEmpty() {
                this.form = {
                    merchatNo: "",
                    agentNo: "",
                    bankNo: "",
                    account: "",
                    withdrawalStatus: ""
                };
                this.updateTimeRange = "";
                if (this.$refs.datePick) {
                    this.$refs.datePick.handleTime();
                }
                try {
                 this.resetPagination();
                } catch (error) {}
            },
            async handleExport() {
                const { data } = await usdtApi.exportWithdrawOrder(this.formatParams());
                if (data) {
                    const BLOB = data;
                    const fileReader = new FileReader();
                    fileReader.readAsDataURL(BLOB);
                    fileReader.onload = (event) => {
                        let a = document.createElement("a");
                        a.download = `USDT-Withdraw-${Number(new Date())}.xlsx`;
                        a.href = event.target.result;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    };
                } else {
                    this.$message.error(this.$t("status.error"));
                }
            },
            _handleSearch() {
                this.$refs.form.validate(async (valid) => {
                    if (valid) {
                        this.getTableData();
                    }
                });
            },
            async handleReview({ id }, withdrawalStatus) {
                const params = { id, withdrawalStatus };
                const service = this.$loading({});
                const { data } = await usdtApi.doReview(params);
                if (data && data.code === 200) {
                    this.$message.success(this.$t("status.success"));
                    this.getTableData()
                        .then(() => {
                            service.close();
                        })
                        .catch((e) => service.close());
                } else {
                    this.$message.error(data.msg);
                    service.close();
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .header-table {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: rgba(0, 0, 0, 0.2);
        padding-right: 40px;

        .list-table {
            display: flex;
            list-style: none;

            li {
                display: flex;
                list-style: none;

                .label {
                    font-style: normal;
                }

                .value {
                    display: flex;
                    list-style: none;
                }
            }

            li:nth-child(n + 2) {
                margin-left: 30px;
            }
        }

        .btn-table {
            margin-left: auto;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/usdt/withdrawlist.vue